var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"tw-overflow-hidden"},[_c('div',{class:_vm.left ? 'line1-left' : 'line1-right',style:(_vm.lineStyle)}),_c('div',{class:_vm.left ? 'line2-left' : 'line2-right',style:(_vm.lineStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }